import * as z from 'zod/mini'

/** A signed-in user joining an event, for themselves or a child user they manage (`userId`). */
export const createClientEventParticipationBody = z.object({
  userId: z.uuid(),
  confirmed: z.optional(z.boolean()),
})
export type CreateClientEventParticipationBody = z.infer<typeof createClientEventParticipationBody>
